import React, { createContext, useContext } from 'react'
import { Toast, ShowToast as showToast } from '@energytoolbase/components'

export interface ToastContext {
  readonly showToast: typeof showToast
}

export interface ToastProviderProps {
  readonly children: React.ReactNode
}

const ToastContext = createContext<ToastContext | null>(null)

export function ToastProvider({ children }: ToastProviderProps): JSX.Element {
  return (
    <ToastContext.Provider value={{ showToast }}>
      <>
        <Toast />
        {children}
      </>
    </ToastContext.Provider>
  )
}

export function useToast(): ToastContext {
  const context = useContext(ToastContext)

  if (!context) {
    throw new Error(
      'Failed to use toast hook, are you sure you wrapped components with an ToastProvider?'
    )
  }

  return context
}
